<template>
  <v-container>
    <v-col>
      <h2>Verze ROBisu a informace o nich</h2>
      <br>

      <h3>Chystáme:</h3>
      <p>Po konci sezóny 2026 dojde k odstranění možnosti nahrávat výsledky ve formátu CSV.</p>
      <br>

      <!-- Verze a její popis se píše do samostatného js souboru tak aby mohl být importován do footru a ve versionPage -->
      <div v-for="version in versions" :key="version.version">
        <h3>verze {{ version.version }}</h3>
        <h5>{{ version.date }}</h5>
          <li v-for="note in version.notes" :key="note">{{ note }}</li>
        <br>
      </div>

    </v-col>
  </v-container>
</template>

<script setup>
import { versions } from '../composables/version.js';

</script>



<style scoped>

h3 {
        color:red;
    }




</style>
